import { createBrandFileAsync } from './../actions';
import { getType } from '@anm/helpers/saga/typesafe-actions';
import { Reducer } from 'redux';

import {
  clearUploadedBrand,
  deleteBrandLogoAsync,
  fetchBrandsAsync,
  updateCurrentBrandId,
  uploadBrandLogoAsync
} from '../actions';
import { BrandActions, BrandState } from '../types';

import deleteBrandLogoReducer from './deleteBrandLogoReducer';
import fetchBrandsReducer from './fetchBrandsReducer';
import uploadBrandReducer from './uploadBrandlogoReducer';
import createBrandFileReducer from './createBrandFileReducer';

export const initialBrandState: BrandState = {
  brandsList: {
    data: [],
    isError: false,
    isPending: false
  },
  uploadBrandLogo: {
    uploadedImageUrl: '',
    isError: false,
    isPending: false
  },
  deleteBrandLogo: {
    error: null,
    isError: false,
    isPending: false
  },
  createBrandFile: {
    error: null,
    isError: false,
    isPending: false,
    createdFile: null
  }
};

const brandsReducer: Reducer<BrandState, BrandActions> = (state = initialBrandState, action) => {
  switch (action.type) {
    case getType(fetchBrandsAsync.request):
    case getType(fetchBrandsAsync.success):
    case getType(fetchBrandsAsync.failure):
    case getType(updateCurrentBrandId):
      return fetchBrandsReducer(state, action);

    case getType(uploadBrandLogoAsync.request):
    case getType(uploadBrandLogoAsync.success):
    case getType(uploadBrandLogoAsync.failure):
    case getType(clearUploadedBrand):
      return uploadBrandReducer(state, action);

    case getType(deleteBrandLogoAsync.request):
    case getType(deleteBrandLogoAsync.success):
    case getType(deleteBrandLogoAsync.failure):
      return deleteBrandLogoReducer(state, action);

    case getType(createBrandFileAsync.request):
    case getType(createBrandFileAsync.success):
    case getType(createBrandFileAsync.failure):
      return createBrandFileReducer(state, action);

    default:
      return state;
  }
};

export default brandsReducer;
